module.exports = __webpack_public_path__ + "images/marketing/white_texture.png";